import { PUBLIC_METAFY_ENV, PUBLIC_STAGING_ID } from '$env/static/public';
import { browser } from '$app/environment';

// Uncomment this line to point to a staging instance instead of the local server:
// export const BASE_IRK_API_URL =
//   PUBLIC_METAFY_ENV === 'development' ? 'https://main.staging.metafy.gg' : browser ? '' : 'http://metafy-api';
// Then comment the lines below:
export const BASE_IRK_API_URL =
  PUBLIC_METAFY_ENV === 'development' ? 'http://localhost:2301' : browser ? '' : 'http://metafy-api';

export const PROXY_STAGING_URL = PUBLIC_METAFY_ENV === 'staging' ? 'https://staging.metafy.gg' : '';

export const BASE_APP_URL =
  PUBLIC_METAFY_ENV === 'development'
    ? 'http://localhost:3000'
    : PUBLIC_METAFY_ENV === 'staging'
      ? `https://${PUBLIC_STAGING_ID}.staging.metafy.gg`
      : 'https://metafy.gg';

export const BASE_APP_STAGING_AWARE_URL = PUBLIC_METAFY_ENV === 'staging' ? PROXY_STAGING_URL : BASE_APP_URL;

export const SHORTEN_APP_URL = PUBLIC_METAFY_ENV === 'production' ? 'https://mfy.gg' : BASE_APP_URL;

export const IRK_API_URL = `${BASE_IRK_API_URL}/irk`;

export const STATIC_URL =
  PUBLIC_METAFY_ENV === 'development'
    ? 'https://static.metafy.gg'
    : PUBLIC_METAFY_ENV === 'staging'
      ? 'https://static-staging.metafy.gg'
      : 'https://static.metafy.gg';

export const TENOR_API_URL = 'https://g.tenor.com/v1';
export const TENOR_API_URL_V2 = 'https://tenor.googleapis.com/v2';

export const IOS_APP_URL = 'https://apps.apple.com/app/metafy/id1556757238';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=gg.metafy.android';

export const RESIZER_URL =
  PUBLIC_METAFY_ENV === 'staging' ? 'https://resize.metafy.gg/staging' : 'https://resize.metafy.gg';

export const METAFY_COMMUNITY_ID = 'eb516bad-1732-42ef-969d-0958ff556ff9';
